// 获取用户信息cookie
export function getDocumentCookie() {
    var cookiepre = "";
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        var re = /yTGF__.*_userinfo/;
        for (var i = 0; i < cookies.length; i++) {
            if (re.test(cookies[i])) {
                var cookie = cookies[i].split("=");
                cookiepre = cookie[0].trim();
                continue;
            }
        }
    }
    return cookiepre;
}

// 原生ajax
export function fileAjax(path, filddata, success) {
    var xhr = null;
    var ActiveXObject;
    if (window.XMLHttpRequest) {
        // 非IE内核
        xhr = new XMLHttpRequest();
    } else if (window.ActiveXObject) {
        ActiveXObject = window.ActiveXObject;
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }
    if (xhr) {
        xhr.open("POST", path);
        xhr.send(filddata);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                var resultValue = xhr.responseText;
                success(JSON.parse(resultValue));
                xhr = null;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/util/utils.js